import styled from '@emotion/styled'

import { getMooncakeContentStyle } from '../../styles/content'

const MooncakeStructuredContent = styled.div`
  ${props => getMooncakeContentStyle(props.theme)}
`

export default MooncakeStructuredContent
